import React, { useState } from "react";
import {
  Box,
  Button,
  Modal,
  Paper,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton,
  Card,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "../../../../shared/FileUploader/FileUpload";
import useFetchWithAuth from "../../../../features/hooks/useFetchWithAuth";
import fetchWithAuth from "../../../../util/fetchWithAuth";
import { API_URL } from "../../../../util/url";

const AddCrossModal = ({ openModal, handleClose }) => {
  const [formValues, setFormValues] = useState({
    name: "",
    price: "",
    crmId: "",
    quantity: "",
    inStock: "yes",
    description: "",
    cross_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleChange = (field) => (e) => {
    setFormValues((prev) => ({ ...prev, [field]: e.target.value }));
  };
  const handleFileChange = (files) => {
    setFormValues((prev) => ({ ...prev, image: files[0] })); // если один файл
  };

  const handleSave = async () => {
    if (
      !formValues.name ||
      !formValues.price ||
      !formValues.quantity ||
      !formValues.crmId
    ) {
      alert("Заполните все обязательные поля");
      return;
    }

    setLoading(true);
    setError(null);
    const formData = new FormData();
    formData.append("cross_id", formValues.cross_id);
    formData.append("title", formValues.name);
    formData.append("quantity", Number(formValues.quantity));
    formData.append("price", Number(formValues.price));
    formData.append("crm", Number(formValues.crmId));
    formData.append("in_stock", formValues.inStock);
    formData.append("description", formValues.description);
    formData.append("image", formValues.image);
    console.log(formData);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/scripts/cross-products/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Ошибка при сохранении");

      const data = await response.json();
      console.log("Создано:", data);
      handleClose();
    } catch (err) {
      console.error(err);
      setError(err);
      alert("Не удалось сохранить крос");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <Box
        component={Paper}
        className="rmui-card"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 3,
          outline: "none",
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h6">Додати крос</Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Загрузка файла */}
        <Card
          sx={{
            width: "100%",
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 1,
            mb: 3,
          }}
        >
          <FileUpload onFileSelect={handleFileChange} />
        </Card>

        {/* Название */}
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ mb: 1 }}>Назва кроса</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={formValues.name}
            onChange={handleChange("name")}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ mb: 1 }}>ID кроса</Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={formValues.cross_id}
            onChange={handleChange("cross_id")}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            mb: 3,
          }}
        >
          {/* Ціна */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ mb: 1 }}>Ціна</Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={formValues.price}
              onChange={handleChange("price")}
            />
          </Box>

          {/* ID з CRM */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ mb: 1 }}>ID з CRM</Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={formValues.crmId}
              onChange={handleChange("crmId")}
            />
          </Box>

          {/* Кількість */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ mb: 1 }}>Кількість</Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={formValues.quantity}
              onChange={handleChange("quantity")}
            />
          </Box>
        </Box>

        {/* В наявності */}
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ mb: 1 }}>В наявності?</Typography>
          <RadioGroup
            row
            value={formValues.inStock}
            onChange={handleChange("inStock")}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Так" />
            <FormControlLabel value="no" control={<Radio />} label="Ні" />
          </RadioGroup>
        </Box>

        {/* Опис товару */}
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ mb: 1 }}>Опис товару</Typography>
          <TextField
            fullWidth
            multiline
            minRows={5}
            variant="outlined"
            value={formValues.description}
            onChange={handleChange("description")}
          />
        </Box>

        {/* Кнопки */}
        <Box mt={3} display="flex" gap={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={loading}
            sx={{ borderRadius: 25, textTransform: "none" }}
          >
            <Typography variant="subtitle2">
              {loading ? "Збереження..." : "Додати"}
            </Typography>
          </Button>
          <Button
            sx={{ borderRadius: 25, textTransform: "none" }}
            onClick={handleClose}
          >
            Закрити
          </Button>
        </Box>

        {error && (
          <Typography sx={{ mt: 2 }} color="error">
            Помилка: {error.message}
          </Typography>
        )}
      </Box>
    </Modal>
  );
};
export default AddCrossModal;
